<svg
  [attr.viewBox]="viewBox"
  [attr.height]="height"
  [attr.width]="width"
  [style.height.px]="height"
  [style.width.px]="width"
  xmlns="http://www.w3.org/2000/svg"
  aria-label="Fraction"
>
  <text
    *ngIf="!useTextInput"
    x="50%"
    y="51%"
    dominant-baseline="middle"
    text-anchor="middle"
    [attr.fill]="color"
    [attr.font-size]="fontSize"
    [attr.font-family]="fontFamily"
    [attr.font-weight]="fontWeight"
  >
    {{ value }}
  </text>

  <svg x="0" y="24%" width="100%" height="48%">
    <foreignObject
      class="input-wrapper"
      *ngIf="useTextInput"
      x="0"
      y="0"
      width="100%"
      height="100%"
    >
      <body xmlns="http://www.w3.org/1999/xhtml">
        <input
          type="text"
          class="input"
          gameFocus
          msVirtualKeyboard
          [formControl]="valueControl"
          [style.font-size.px]="fontSize"
          [style.font-family]="fontFamily"
          [style.font-weight]="fontWeight"
          [style.color]="color"
          [readonly]="readonly"
        />
      </body>
    </foreignObject>
  </svg>
</svg>

<ng-content></ng-content>
<!-- <div class="extras">
</div> -->
